import { AppRouter } from './router';
import { ErrorBoundary } from './components/common/ErrorBoundary';

export const App = () => {
  return (
    <ErrorBoundary>
      <AppRouter />
    </ErrorBoundary>
  );
};

